var ChangeUserPasswordForm = React.createClass({
  propTypes: {
    user: React.PropTypes.object.isRequired,
    onSaveDone: React.PropTypes.func.isRequired,
    onCancel: React.PropTypes.func.isRequired
  },
  getInitialState() {
    return {
      currentPassword: "",
      password: "",
      confirm: ""
    }
  },
  inputChanged(e) {
    let key = e.target.getAttribute("name");
    let o = {};
    o[key] = e.target.value;
    this.setState(o);
  },
  saveClicked(e) {
    e.preventDefault();

    if (!this.validateForm()) return;

    let data = {
      currentPassword: this.state.currentPassword,
      password: this.state.password,
      SToken: Config.csrf.value
    };

    let url = `${Config.contextPath}/controller/save/userprofile/`;
    $.post(url, data)
      .done(r => {
        if (r.success) {
          this.props.onSaveDone(r.user);
        } else {
          this.showError(r.message);
        }
      });
  },
  validateForm() {
    let {
      currentPassword,
      password,
      confirm
    } = this.state;

    this.clearError();

    if (RA.Utils.isBlank(currentPassword)) {
      this.showError(Labels.getLabel("Enter your current password"));
      return false;
    }

    if (RA.Utils.isBlank(password)) {
      this.showError(Labels.getLabel("Enter your new password"));
      return false;
    }

	if (!RA.Utils.isValidPwdCharacters(password)) {
      this.showError(Labels.getLabel("Values cannot contain <,> or %."));
      return false;
    }

    if (password != confirm) {
      this.showError(Labels.getLabel("Passwords do not match."));
      return false;
    }

    return true;
  },
  clearError() {
    this.setState({errorMessage: ""});
  },
  showError(message) {
    this.setState({errorMessage: message});
    window.scrollTo(0, this.refs.form.offsetTop);
    $(this.refs.errorWrap).hide().fadeIn("fast");
  },
  renderError() {
    if (RA.Utils.isNotBlank(this.state.errorMessage)) {
      return  (
        <div ref="errorWrap">
          <AlertMessage alertType="danger">
            <strong>{Labels.getLabel("Error")}:</strong>
            {" " + this.state.errorMessage}
          </AlertMessage>
        </div>
      )
    }
  },
  render() {
    return (

      <form onSubmit={this.saveClicked} ref="form">
        <h2 className="form__title">{Labels.getLabel("Change Password")}</h2>

        {this.renderError()}

        <div className="form-group has-float-label">
          <input type="password" autocomplete="new-password" id="profileCurrentPassword" className="form-control" name="currentPassword"
            maxLength="50" onChange={this.inputChanged} value={this.state.currentPassword} placeholder="&nbsp;"/>
          <label htmlFor="profileCurrentPassword">{Labels.getLabel("Current Password")}</label>
        </div>

        <div className="form-group has-float-label">
          <input type="password" autocomplete="new-password" id="profilePassword" className="form-control" name="password"
            maxLength="50" onChange={this.inputChanged} value={this.state.password} placeholder="&nbsp;"/>
          <label htmlFor="profilePassword">{Labels.getLabel("New Password")}</label>
        </div>

        <div className="form-group has-float-label">
          <input type="password" autocomplete="new-password" id="profileConfirmPassword" className="form-control" name="confirm"
            maxLength="50" onChange={this.inputChanged} value={this.state.confirm} placeholder="&nbsp;"/>
          <label htmlFor="profileConfirmPassword">{Labels.getLabel("Confirm Password")}</label>
        </div>

        <div className="text-right">
          <button type="submit" className="btn btn-primary" onClick={this.saveClicked}>{Labels.getLabel("Save")}</button>
          {" "}
          <button type="button" className="btn btn-default" onClick={this.props.onCancel}>{Labels.getLabel("Cancel")}</button>
        </div>
      </form>
    );
  }
});